var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"color":"primary","size":_vm.size}},[(_vm.user?.userProfilePicture)?_c('v-img',{attrs:{"src":_vm.MIX_getImagePath(_vm.file?.fileFolder, _vm.file?.fileName, _vm.file?.fileToken)}}):_vm._e(),(!_vm.user?.userProfilePicture)?_c('app-text',{attrs:{"color":"white"}},[_vm._v(_vm._s(_vm.computedGetInitials))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }